import { getOrderDetail } from 'client/receipt/receipt.client'

export const temperatureLoader = async ({ params }) => {
  return await getOrderDetail(String(params.receiptId))
}
